import BaseIcon from './base-icon';

class RefreshIcon extends BaseIcon {
  renderSVG(): string {
    return `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        stroke="currentColor"
        stroke-width="2"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.1679 8C19.6246 4.46819 16.1006 2 11.9999 2C6.81459 2 2.55104 5.94668 2.04932 11"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M17 8H21.4C21.7313 8 22 7.73137 22 7.4V3" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M2.88146 16C4.42458 19.5317 7.94874 22 12.0494 22C17.2347 22 21.4983 18.0533 22 13"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.04932 16H2.64932C2.31794 16 2.04932 16.2686 2.04932 16.6V21"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;
  }
}

customElements.define('refresh-icon', RefreshIcon);
